import apiClient from "./api_client";

const interviewService = {
  // Get all interviews with optional filters
  getAll: async (status = null, dateFrom = null, dateTo = null) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (dateFrom) params.append("date_from", dateFrom);
    if (dateTo) params.append("date_to", dateTo);
    
    const response = await apiClient.get(`/interviews?${params.toString()}`);
    return response;
  },

  // Get interview dashboard stats
  getDashboardStats: async () => {
    const response = await apiClient.get("/interviews/dashboard/stats");
    return response;
  },

  // Check for scheduling conflict
  checkConflict: async (date, startTime, endTime, excludeId = null) => {
    const params = new URLSearchParams({
      date: date,
      start_time: startTime,
      end_time: endTime,
    });
    if (excludeId) params.append("exclude_id", excludeId);
    
    const response = await apiClient.get(`/interviews/check-conflict?${params.toString()}`);
    return response;
  },

  // Get interview by application ID - returns {exists: bool, interview: obj|null}
  getByApplication: async (applicationId) => {
    const response = await apiClient.get(`/interviews/by-application/${applicationId}`);
    return response;
  },

  // Get specific interview by ID
  getById: async (interviewId) => {
    const response = await apiClient.get(`/interviews/${interviewId}`);
    return response;
  },

  // Create new interview
  create: async (interviewData) => {
    const response = await apiClient.post("/interviews", interviewData);
    return response;
  },

  // Update existing interview
  update: async (interviewId, interviewData) => {
    const response = await apiClient.put(`/interviews/${interviewId}`, interviewData);
    return response;
  },

  // Cancel interview
  cancel: async (interviewId) => {
    const response = await apiClient.delete(`/interviews/${interviewId}`);
    return response;
  },

  // Prepare interview with AI
  prepareInterview: async (payload) => {
    const response = await apiClient.post("/interviews/prepare", payload);
    return response;
  },

  // Save questions to interview
  saveQuestions: async (interviewId, questions) => {
    const response = await apiClient.post(`/interviews/${interviewId}/questions`, questions);
    return response;
  },

  // Get interview questions
  getQuestions: async (interviewId) => {
    const response = await apiClient.get(`/interviews/${interviewId}/questions`);
    return response;
  },

  // Evaluate interview
  evaluate: async (interviewId, evaluationData) => {
    const response = await apiClient.post(`/interviews/${interviewId}/evaluate`, evaluationData);
    return response;
  },

  // Get interview evaluation
  getEvaluation: async (interviewId) => {
    const response = await apiClient.get(`/interviews/${interviewId}/evaluation`);
    return response;
  },
};

export default interviewService;
